module.exports = __webpack_public_path__ + "static/media/azimut-icons.4961585f.eot";